import { Map } from 'immutable';
import { setUploadError } from './uploadProgress';
import { removeUploadFile } from '../registration-completion/view/step_identity_check/h&s';
import { UploadUtils } from './imageUtils';
import { dispatch, pathSubscription } from 'nike-re-framejs';

export function documentUpload(slotDescription, file) {
    const uploadContext = Map({ file, slotDescription });
    return () => {
        dispatch(removeUploadFile(slotDescription));
        Promise.resolve(uploadContext)
            .then(UploadUtils.determineFileType)
            .then(UploadUtils.resizeIfImage)
            .then(UploadUtils.validateNonImageFileSize)
            .then(UploadUtils.upload)
            .then(UploadUtils.persistVersion)
            .catch(error => {
                console.error('upload error', error);
                setTimeout(() => dispatch(setUploadError(uploadContext, error?.uploadErrorText)), 1000);
            });
    };
}

export const getUploadProgress = (slot, idDoc, page) =>
    pathSubscription(['dms', 'model', 'docs', slot, idDoc, 'files', page, 'upload']);

export const getUploadError = (slot, idDoc, page) =>
    pathSubscription(['dms', 'model', 'docs', slot, idDoc, 'files', page, 'upload', 'error']);

export const getUploadVersion = (slot, idDoc, page) =>
    pathSubscription(['dms', 'model', 'docs', slot, idDoc, 'files', page, 'version']);
